export default {"src":"/_next/static/media/ach_bank_icon.195d54e0.svg","height":26,"width":77,"blurWidth":0,"blurHeight":0};